import { useState, useEffect } from 'react';
import { adminService } from '../services/adminService';

/**
 * Whether a feature flag is enabled for the current tenant.
 * Returns `undefined` while loading. Fails open (`true`) if the flag
 * doesn't exist yet or the lookup errors, so a fetch hiccup never
 * silently hides a page nobody meant to disable.
 */
export function useFeatureFlag(flagKey: string): boolean | undefined {
  const [enabled, setEnabled] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    let cancelled = false;
    adminService
      .getFeatureFlags()
      .then((flags) => {
        if (cancelled) return;
        const flag = flags.find((f) => f.flagKey === flagKey);
        setEnabled(flag ? flag.enabled : true);
      })
      .catch(() => {
        if (!cancelled) setEnabled(true);
      });
    return () => {
      cancelled = true;
    };
  }, [flagKey]);

  return enabled;
}
